import { request } from './client.js';

export type ExportKind = 'pdf_print' | 'pdf_screen' | 'png_zip';
export type ExportStatus = 'queued' | 'running' | 'succeeded' | 'failed' | 'cancelled';

export interface ExportDto {
  readonly id: string;
  readonly kind: ExportKind;
  readonly status: ExportStatus;
  readonly progress: number;
  readonly cached: boolean;
  readonly pageCount: number | null;
  readonly paddedPages: number | null;
  readonly error: string | null;
  readonly downloadUrl: string | null;
  readonly downloadUrlExpiresAt: string | null;
  readonly createdAt: string;
  readonly finishedAt: string | null;
}

export const exportsApi = {
  list: (bookId: string) => request<{ items: readonly ExportDto[] }>(`/books/${bookId}/exports`),
  create: (bookId: string, kind: ExportKind) =>
    request<ExportDto>(`/books/${bookId}/exports`, { method: 'POST', body: { kind } }),
};
